import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function FinalClassification() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
    <fieldset>
      <legend>{t("Final Classification")}</legend>
      <input
        type="text"
        onChange={onChange}
        value={searchObject.finalClassification || ""}
        name="finalClassification"
        className="form-control"
      />
    </fieldset>
  );
}
